export default "__VITE_ASSET__BWv6Y6jE__"